import React, { useMemo } from 'react';
import Tabs from 'components/Tabs';
import TEXT_STRING from 'constants/string';
import { ESearchTab, TSchedule, TFilterTime } from 'types';
import CustomSelect from 'components/CustomSelect';
import { formatDate } from 'utils';

const DATE_OPTION_FORMAT = 'MM/DD(dd)';

const listTab = [
  {
    title: TEXT_STRING.SEARCH_PAGE.SCHEDULES,
    id: ESearchTab.SCHEDULES,
  },
  {
    title: TEXT_STRING.SEARCH_PAGE.RANKING,
    id: ESearchTab.RANKING,
  },
  {
    title: TEXT_STRING.SEARCH_PAGE.LIST_EMPLOYEES,
    id: ESearchTab.LIST_EMPLOYEE,
  },
  {
    title: TEXT_STRING.SEARCH_PAGE.HOT_VIDEO,
    id: ESearchTab.HOT_VIDEO,
  },
];

type Props = {
  tab: ESearchTab;
  onChangeTab: (tab: string) => void;
  searchInput: React.ReactNode;
  selectedDate: TFilterTime;
  handleSelectedDate: (day: TSchedule) => void;
  currentWeeks: TSchedule[];
  containerRef: React.RefObject<HTMLDivElement>;
  visible?: boolean;
};

const StickySearchHeader = ({
  tab,
  onChangeTab,
  searchInput,
  selectedDate,
  handleSelectedDate,
  currentWeeks,
  containerRef,
  visible = true,
}: Props) => {
  const dateOptions = useMemo(
    () =>
      currentWeeks.map((day, index) => {
        const label = formatDate(day.startDate, DATE_OPTION_FORMAT);
        return {
          value: day.startDate,
          name:
            index === 0 ? `${TEXT_STRING.SEARCH_PAGE.TODAY} ${label}` : label,
          disabled: day.disabled,
        };
      }),
    [currentWeeks],
  );

  const selectedLabel = useMemo(
    () => formatDate(selectedDate.startTime, DATE_OPTION_FORMAT),
    [selectedDate.startTime],
  );

  return (
    <div
      ref={containerRef}
      className="sticky -top-0.5 z-10 flex flex-col shadow-sm bg-white w-full overflow-hidden transition-[transform] duration-300 ease-out"
      style={
        visible
          ? { transform: 'translateY(0px)' }
          : { transform: 'translateY(-100%)' }
      }
    >
      <div className="w-full flex items-center">
        <Tabs
          className="my-[16px] mx-[8px] w-full"
          currentTab={tab}
          tabs={listTab}
          onChangeTab={onChangeTab}
        />
      </div>

      {tab === ESearchTab.SCHEDULES ? (
        <div className="w-full px-8px pb-3 flex items-center gap-2">
          <div className="w-2/5 flex-shrink-0">
            <CustomSelect
              name="selectedDate"
              value={selectedDate.startTime}
              ariaLabel={selectedLabel}
              options={dateOptions}
              icon="calendar"
              renderValue={() => selectedLabel}
              onChange={(value) => {
                const day = currentWeeks.find((d) => d.startDate === value);
                if (day) handleSelectedDate(day);
              }}
            />
          </div>
          <div className="min-w-0 flex-1">{searchInput}</div>
        </div>
      ) : (
        <div className="w-full px-8px pb-3 flex items-center">
          {searchInput}
        </div>
      )}
    </div>
  );
};

export default StickySearchHeader;
